import { useEffect, useState } from "react";
import config from '../../../config/configJS';
import { useChatEnvironmentAtom } from "../../../atoms/chat/useChatEnvironmentAtom";
import { useTranslation } from 'react-i18next';
import ImageModal from "./ImageModal";

const ImageGallery = ({ idString }) => {

    const [ids, setIds] = useState([]);
    const [displayedIds, setDisplayedIds] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [moreImagesAvailable, setMoreImagesAvailable] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [chatEnvironmentId] = useChatEnvironmentAtom();
    const [t,] = useTranslation('global');

    useEffect(() => {
        const idsArray = idString.split(',');
        setIds(idsArray);

        const initialDisplayedIds = idsArray.slice(0, 4);
        setDisplayedIds(initialDisplayedIds);
        setCurrentIndex(4);

        if (idsArray.length > 4) {
            setMoreImagesAvailable(true);
        }
    }, [idString]);

    const showMore = () => {
        const nextIndex = currentIndex + 4;
        const newDisplayedIds = ids.slice(0, nextIndex);
        setDisplayedIds(newDisplayedIds);
        setCurrentIndex(nextIndex);

        if (nextIndex >= ids.length) {
            setMoreImagesAvailable(false);
        }
    };
  
    const handleImageClick = (id) => {
        const imageSrc = `${config.endPoint}/api/millai/DownloadFile?intent=GetImageById&DocEnvId=${chatEnvironmentId}&imgid=${id}`;
        setModalImageSrc(imageSrc);
        setShowModal(true);
    };

    return (
        <div className='img-grid'>
            <div className="img-row">
                {displayedIds.map((id, index) => (
                    <div className="img-column" key={index}  onClick={() => handleImageClick(id)}>
                        <img  src={`${config.endPoint}/api/millai/DownloadFile?intent=GetImageById&DocEnvId=${chatEnvironmentId}&imgid=${id}`}/>
                    </div>
                ))}
            </div>

            {moreImagesAvailable && 
            <div className="show-more-container">

                <div className="show-more-label" onClick={showMore}>{t('moreImages')}</div>
                <span className="material-symbols-outlined show-more" onClick={showMore}>
                    image_search
                </span>
            </div>
            }

            <ImageModal show={showModal} imageSrc={modalImageSrc} onClose={()=> setShowModal(false)} />
        </div>
    );

}

export default ImageGallery;